// src/environments/environment.prod.ts

export const environment = {
  production: true,
  apiUrl: 'https://backend-service.lendpeak.io',
};
